import { white } from '@synoptic/ui-kit/palette.js';
import { hairline } from '@synoptic/ui-kit/theme-v2/hairline.js';
import { themeV2 } from '@synoptic/ui-kit/theme-v2/vars.js';
import {
  borderRadius,
  fonts,
  fontSizes,
  fontWeight,
  space,
} from '@synoptic/ui-kit/tokens.js';
import { typography } from '@synoptic/ui-kit/typography.js';
import { globalStyle, style } from '@vanilla-extract/css';
import { summarizePostButton } from '@/components/stream-post-card/summarize/summarize.css.ts';
import { streamPostsSearch } from './page.css.ts';
import { trigger } from './stream-posts-date-range.css.ts';

export const streamDataCardV2 = style({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  minWidth: 0,
  borderRadius: borderRadius.r16,
  backgroundColor: themeV2.color.bg.surface.default,
  overflow: 'hidden',
  '::after': {
    content: '',
    position: 'absolute',
    inset: 0,
    borderRadius: 'inherit',
    boxShadow: hairline(white[50]),
    pointerEvents: 'none',
  },
});

export const streamDataToolbarV2 = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: space.s16,
  flexWrap: 'wrap',
  padding: space.s16,
  borderBottom: `1px solid ${white[50]}`,
});

export const streamDataTitleV2 = style({
  margin: 0,
  fontWeight: fontWeight.medium,
  fontSize: 18,
  lineHeight: 1.3,
  letterSpacing: '-0.03em',
  color: themeV2.color.text.primary,
});

export const streamDataFiltersV2 = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  flexWrap: 'wrap',
  gap: space.s16,
  marginLeft: 'auto',
});

globalStyle(`${streamDataFiltersV2} ${streamPostsSearch}`, {
  width: 189,
  maxWidth: '100%',
});

globalStyle(`${streamDataFiltersV2} ${streamPostsSearch} > div`, {
  height: 36,
  backgroundColor: themeV2.color.bg.surface.secondary,
  outline: `1px solid ${white[50]}`,
});

globalStyle(`${streamDataFiltersV2} ${trigger}`, {
  height: 36,
  padding: `0 ${space.s16}px`,
  gap: space.s8,
  color: white[400],
  backgroundColor: 'transparent',
  outline: `1px solid ${white[50]}`,
});

export const streamEventListV2 = style({});

export const streamEventRowV2 = style({
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  gap: space.s16,
  padding: space.s16,
  backgroundColor: themeV2.color.bg.surface.default,
  borderTop: `1px solid ${white[50]}`,
});

globalStyle(`${streamEventListV2} > :first-child .${streamEventRowV2}`, {
  borderTop: 'none',
});

export const streamEventFallbackBarV2 = style({
  width: '70%',
  height: 16,
  borderRadius: borderRadius.r8,
  backgroundColor: white[50],
});

export const streamEventBodyV2 = style({
  display: 'flex',
  flexDirection: 'column',
  gap: space.s24,
  minWidth: 0,
  flex: '1 1 auto',
});

export const streamEventTextV2 = style({
  ...typography.labelLg,
  fontWeight: fontWeight.medium,
  color: themeV2.color.text.secondary,
});

export const streamEventTimeV2 = style({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: space.s10,
  fontFamily: fonts.mono,
  fontWeight: fontWeight.medium,
  fontSize: fontSizes.bodySm,
  lineHeight: 1.3,
  letterSpacing: '-0.04em',
  color: white[400],
  whiteSpace: 'nowrap',
});

export const streamEventTopicV2 = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: space.s12,
  minWidth: 230,
  flexShrink: 0,
});

export const streamEventActionsV2 = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',
  gap: space.s8,
  marginLeft: 'auto',
});

globalStyle(`${streamEventActionsV2} ${summarizePostButton}`, {
  position: 'static',
});
